<template>
<ViewReputation></ViewReputation>
</template>
<script>
import ViewReputation from "@/components/IAReputation/Views/Reputation.vue"


export default {
    components: {ViewReputation},

}
</script>
